/**
 *
 */
import React from 'react'
import { Table, Divider, DatePicker, Button, Tooltip, Input, Tag } from 'antd'
import moment from 'moment'
import Cell from '../../../components/Cell'
import Crud from '../../../components/Crud'
import Api from '../../../Api'
import Exception from '../../../Exception'
import _ from 'lodash'
import { ImportesSolPago } from '../../Cxp/Components/importesSolPago'
import SolicitudPago from './SolicitudPagoForm'
import { PeriodoInicioTermino } from '../../Com/renta-equipos/periodo-inicio-termino'

export class PagosSolicitadosSub extends React.Component {
  /**
   * Constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      { width: '40%', title: 'INFORMACIÓN', dataIndex: 'ordenCompra.sConsecutivo',  render: (__, record) =>
        <div style={{ marginBottom: 5, flexWrap: 'wrap' }}>
          <Tooltip title='Status de su solicitud de pago'
            children={
              <Tag
                color={record.sEstado !== 'PAGADO' ? undefined : 'green'}
                style={{ minWidth: '90px', textAlign: 'center' }}
              >
                {record.sEstado}
              </Tag>
            }
          />
          {/* <Tooltip title='Tipo de pago'
            children={<Tag>{record.sTipoPago}</Tag>}
          /> */}

          <Tooltip title='Orden de Servicio'
            children={<Tag color='purple'>{_.get(record, 'ordenCompra.sConsecutivo')}</Tag>}
          />

          <Tooltip title='No fact o ref, concepto'
            children={<Tag style={{ textWrap: 'wrap' }} color='orange'>{record.sReferencia}</Tag>}
          />
        </div>
      },
      { width: '35%', title: 'IMPORTES', dataIndex: 'dImporteOriginal', render: (_, record) => (
        <ImportesSolPago
          {...record}
          style={{ flexWrap: 'wrap' }}
        />
      )},
      { width: '20%', title: 'INFORMACIÓN ADICIONAL', dataIndex: 'dImporteOriginal', render: (_, record) => (
        <div>
          {!record.sNumeroEconomico ? null : (
            <Tag children={record.sNumeroEconomico} />
          )}

          {!record.dInicioPeriodo && !record.dTerminoPeriodo ? null : (
            <PeriodoInicioTermino
              inicio={record.dInicioPeriodo}
              fin={record.dTerminoPeriodo}
            />
          )}
        </div>
      )},
      { width: '5%', title: ' ', dataIndex: 'sFolio', render: (_, record) => (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div>
            <Tooltip title='Editar'>
                <Button
                  size='small'
                  shape='circle-outline'
                  icon={record.sEstado === 'ELABORANDO' ? 'edit' : 'folder-open'}
                  style={{ marginRight: 7 }}
                  onClick={() => this.solicitarPago.load(record.iId)}
                />
              </Tooltip>
          </div>
        </div>
      )}
    ])

    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      search: '',
      data: [],
      lookup: [],
    }

    this.solicitarPago = null
  }

  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    const fecha = moment()
    this.fetch(
      fecha.startOf('month').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD')
    )
  }

  /**
   * Cargar
   *
   */
  fetch = async(inicio = -1, termino = -1, search = '') => {
    try {
      this.setState({ loading: true, query: { inicio, termino } })

      const likeSearch = {$like: `%${search}%`}
      const filter = search.length > 0 ? {
        $or: [
          { sFolio: likeSearch },
          { sReferencia: likeSearch },
          { '$ordenCompra.sConsecutivo$': likeSearch },
        ],
      } : {
        $or: [
          { dFechaIngresado: { $eq: null } },
          { dFechaIngresado: { $between: [inicio, termino] } },
        ]
      }

      const response = await querySolicitudesPago(filter)

      this.setState({
        data: response.data,
        loading: false,
        inicio,
        termino,
        search,
      })
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   *
   */
  reload = () => {
    this.fetch(this.state.inicio, this.state.termino, this.state.search)
  }

  /**
   * Render
   */
  render() {
    const crud = (
      <Crud
        buttons={['add', 'reload']}
        onReload={() =>
          this.fetch(
            this.state.inicio,
            this.state.termino,
            this.state.search
          )
        }
        onAdd={() => this.solicitarPago.showModal()}
      />
    )

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
          onChange={
            (items, fechas) =>
              this.fetch(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
                this.state.search,
              )
          } />
        <Divider type='vertical' />
        {crud}
        <Divider type='vertical'/>
        <Input.Search
          placeholder='Buscar'
          style={{ width: 185 }}
          onSearch={value =>
            this.fetch(this.state.inicio, this.state.termino, value.trim())
          }
          allowClear
        />
      </div>
    )

    return (
      <div style={{ flex: 1 }}>
        <SolicitudPago
          ref={ref => this.solicitarPago = ref}
          onCancel={() => this.reload()}
          onSolicitada={() => this.reload()}
          onSave={() => this.reload()}
        />

        <Table
          rowKey='iId'
          size='small'
          rowClassName='row-pure'
          dataSource={this.state.data}
          columns={this.columns}
          loading={this.state.loading}
          pagination={false}
          title={() => tableTitle}
        />
      </div>
    )
  }
}

/**
 *
 * @param {*} filter
 * @returns
 */
function querySolicitudesPago(filter) {
  return Api.query({
    model: "SubOrdenPago",

    attributes: [
      'iId',
      'sFolio',
      'sEstado',
      'dFechaIngresado',
      'sEspecial',
      'iAnticipo',
      'sReferencia',
      'dImporte',
      'dImporteSolicitado',
      'sTipoPago',
      'iIdUsuarioIngreso',
      'dInicioPeriodo',
      'dTerminoPeriodo',
      [
        {
          literal: "@info := fn_sub_orden_pago_importes_info(SubOrdenPago.iId)"
        },
        "importesInfo"
      ],
      [
        {
          literal: "(cast(json_extract(@info, '$.importe_original') as decimal(18, 4)))"
        },
        "dImporteOriginal",
        "float"
      ],
      [
        {
          literal: "cast(json_extract(@info, '$.pendiente_autorizar') as decimal(18, 4))"
        },
        "dImportePendiente",
        "float"
      ],
      [
        {
          literal: "(cast(json_extract(@info, '$.pagado') as decimal(18, 4)))"
        },
        "dImportePagado",
        "float"
      ],
      [
        {
          fn: "fn_sub_orden_pago_adjuntos",
          params: [
            "$SubOrdenPago.iId$"
          ]
        },
        "tiene_adjuntos"
      ],
      [
        {
          fn: "fn_sub_orden_pago_adjuntos_rechazados",
          params: [
            "$SubOrdenPago.iId$"
          ]
        },
        "adjuntos_rechazados"
      ]
    ],

     include: [
      {
        as: "moneda",
        required: true,
        attributes: ["sCodigo"]
      },
      /*{
        as: "project",
        attributes: ['sContrato'],
        include: [
          {
            as: "proyectoPrincipal",
            required: false,
            attributes: ['sContrato']
          }
        ]
      },*/
      {
        as: "ordenCompra",
        attributes: [
          "sConsecutivo"
        ]
      },
      {
        as: "tipoPago",
        attributes: [
          "sDescripcion"
        ]
      },
    ],

    where: {
      iActivo: true,
      iIdProveedor: Api.getProviderId(),
      sEstado: { $ne: 'PENDIENTE' },
      ...filter,
    },

    order: [
      [
        "iId",
        "DESC"
      ]
    ]
  })
}

